import * as React from 'react'

import { Typography } from '@material-ui/core'
import ReactSVG from 'react-svg'

import './style.scss'

interface IProps {
  time: number
  unit?: string
  onClick?: () => void
}

interface IState {}

export class EstimatedTime extends React.PureComponent<IProps, IState> {
  render() {
    const { time, unit, onClick } = this.props
    return (
      <div className="estimated-time" onClick={time ? onClick : undefined}>
        <ReactSVG
          src={require('../../assets/img/clock.svg')}
          className="clock"
        />
        {time && (
          <Typography className="time">
            {time} {unit || 'min'}
          </Typography>
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/EstimatedTime/index.tsx